import { observable, action, makeObservable } from 'mobx';

import { FeatureName } from 'chaika-enums';

import type { FeatureToggleParams, IFeatureToggle } from './types';
import { DateHelper } from '@utils/DateHelper';

export class FeatureToggle implements IFeatureToggle, Record<FeatureName, FeatureToggleParams> {
    @observable public [FeatureName.UseEntryReview]: FeatureToggleParams = {
        expiredAt: DateHelper.addMonths(new Date(), 1).toISOString(),
        availableForAll: false,
        availableForUsers: [],
        availableForOrganizations: [],
    };

    @observable public [FeatureName.AsyncReceipts]: FeatureToggleParams = {
        expiredAt: DateHelper.addMonths(new Date(), 1).toISOString(),
        availableForAll: false,
        availableForUsers: [],
        availableForOrganizations: [],
    };

    @observable public [FeatureName.UseServiceCoverageStatus]: FeatureToggleParams = {
        expiredAt: DateHelper.addMonths(new Date(), 1).toISOString(),
        availableForAll: false,
        availableForUsers: [],
        availableForOrganizations: [],
    };

    @observable public [FeatureName.ServiceCoverageStatusTab]: FeatureToggleParams = {
        expiredAt: DateHelper.addMonths(new Date(), 1).toISOString(),
        availableForAll: false,
        availableForUsers: [],
        availableForOrganizations: [],
    };

    @observable public [FeatureName.RealtimeDictation]: FeatureToggleParams = {
        expiredAt: DateHelper.addMonths(new Date(), 1).toISOString(),
        availableForAll: false,
        availableForUsers: [],
        availableForOrganizations: [],
    };

    @observable public [FeatureName.CdaGeneration]: FeatureToggleParams = {
        expiredAt: DateHelper.addMonths(new Date(), 1).toISOString(),
        availableForAll: false,
        availableForUsers: [],
        availableForOrganizations: [],
    };

    @observable public [FeatureName.PushFirstNotifications]: FeatureToggleParams = {
        expiredAt: DateHelper.addMonths(new Date(), 1).toISOString(),
        availableForAll: false,
        availableForUsers: [],
        availableForOrganizations: [],
    };

    @observable public [FeatureName.SplitPayment]: FeatureToggleParams = {
        expiredAt: DateHelper.addMonths(new Date(), 1).toISOString(),
        availableForAll: false,
        availableForUsers: [],
        availableForOrganizations: [],
    };

    @observable public [FeatureName.PatientAppInsteadOfTelegram]: FeatureToggleParams = {
        expiredAt: DateHelper.addMonths(new Date(), 1).toISOString(),
        availableForAll: false,
        availableForUsers: [],
        availableForOrganizations: [],
    };

    constructor() {
        makeObservable(this);
    }

    public isAvailableForUser(name: FeatureName, userId: string, mainOrganizationId?: string | null): boolean {
        this.checkExpired(name);
        const params = this[name];
        if (!params) {
            return false;
        }

        return (
            params.availableForAll ||
            params.availableForUsers.includes(userId) ||
            (!!mainOrganizationId && (params.availableForOrganizations ?? []).includes(mainOrganizationId))
        );
    }

    public isAvailableForUserStrict(name: FeatureName, userId: string): boolean {
        this.checkExpired(name);
        const params = this[name];
        return !!params && params.availableForUsers.includes(userId);
    }

    @action
    public setFeaturePrams(name: FeatureName, params: FeatureToggleParams): void {
        this[name] = params;
    }

    private checkExpired(name: FeatureName): void {
        // if (DateHelper.isBefore(this[name].expiredAt, new Date())) {
        //     console.warn(`Feature flag for ${name} expired!`);
        // }
    }
}
